export const styles = {
  container: {
    'section .content': {
      pt: 'headerHeight',
      minHeight: 'unset !important',
      mt: 0,
    },
  },
};
